import type { RoutineTemplateRepository } from '../../../application/ports/RoutineTemplateRepository';
import type { RoutineTemplate } from '../../../domain/routine/models';
import type { ProfileId, RoutineTemplateId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { RoutineTemplateMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexieRoutineTemplateRepository implements RoutineTemplateRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(template: RoutineTemplate): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.routineTemplates.put(RoutineTemplateMapper.toRecord(template));
    });
  }

  public findById(id: RoutineTemplateId): Promise<RoutineTemplate | null> {
    return executePersistence('read', async () => {
      const record = await this.database.routineTemplates.get(id);
      return record ? RoutineTemplateMapper.fromRecord(record) : null;
    });
  }

  public listByProfile(profileId: ProfileId): Promise<readonly RoutineTemplate[]> {
    return executePersistence('read', async () =>
      (await this.database.routineTemplates.where('profileId').equals(profileId).toArray()).map(
        (record) => RoutineTemplateMapper.fromRecord(record),
      ),
    );
  }

  public delete(id: RoutineTemplateId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.routineTemplates.delete(id);
    });
  }

  public clearForProfile(profileId: ProfileId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.routineTemplates.where('profileId').equals(profileId).delete();
    });
  }
}
